import { render, staticRenderFns } from "./Demvendedores.vue?vue&type=template&id=7bfb822a&"
import script from "./Demvendedores.vue?vue&type=script&lang=js&"
export * from "./Demvendedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports